import React, { useState } from "react";
import API from "@/lib/api";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star } from "lucide-react";
import { toast } from "sonner";

export function ReviewDialog({ rid, revieweeId, revieweeName, onDone, triggerLabel = "Lascia una recensione", triggerTestid = "leave-review-button" }) {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await API.post(`/requests/${rid}/reviews`, { reviewee_id: revieweeId, rating, comment });
      toast.success("Recensione inviata. Grazie!");
      setOpen(false);
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid={triggerTestid} size="sm" className="rounded-full bg-[#1F4FE0] hover:bg-[#1A44C2] text-white">
          <Star size={14} className="mr-1" /> {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif">Recensisci {revieweeName}</DialogTitle>
          <DialogDescription>Il tuo giudizio aiuta la community a fidarsi.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="flex items-center gap-1" data-testid="review-stars">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} type="button" data-testid={`review-star-${n}`} onClick={() => setRating(n)}
                onMouseEnter={() => setHover(n)} onMouseLeave={() => setHover(0)} className="p-1">
                <Star size={28} className={(hover || rating) >= n ? "fill-[#FFB800] text-[#FFB800]" : "text-[#C9C9D6]"} />
              </button>
            ))}
          </div>
          <Textarea data-testid="review-comment" placeholder="Com'è andata? (facoltativo)" value={comment} onChange={(e) => setComment(e.target.value)} />
        </div>
        <DialogFooter>
          <Button data-testid="review-submit" onClick={submit} disabled={saving} className="bg-[#1F4FE0] text-white rounded-full">Invia recensione</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
